import { useState } from 'react'

import { FAQ_ITEMS } from './constants'
import SectionHeading from '../shared/SectionHeading'
import styles from './styles.module.scss'

const FaqSection = (): JSX.Element => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  return (
    <section className={`${styles.block} ${styles.faq}`} id="faq">
      <div className={`${styles.content} ${styles.center}`}>
        <SectionHeading
          eyebrow="よくある質問"
          title="紹介する前に、知っておきたいこと"
          description="紹介・導入・報酬について、よくいただくご質問をまとめました。"
        />
        <div className={`${styles.faqList} ${styles.reveal}`} data-reveal="">
          {FAQ_ITEMS.map((item, index) => {
            const isOpen = openIndex === index
            return (
              <div className={`${styles.faqItem} ${isOpen ? styles.open : ''}`} key={item.question}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${index}`}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                >
                  <span>Q</span>
                  {item.question}
                  <i aria-hidden="true" />
                </button>
                <div id={`faq-answer-${index}`} className={styles.faqAnswer} aria-hidden={!isOpen}>
                  <div>{item.answer}</div>
                </div>
              </div>
            )
          })}
        </div>
        <p className={`${styles.faqMore} ${styles.reveal}`} data-reveal="">
          その他のご質問は{' '}
          <a href="https://intercom.help/ecbocloak" target="_blank" rel="noopener noreferrer">
            ヘルプページ
          </a>{' '}
          もご参照ください。
        </p>
      </div>
    </section>
  )
}

export default FaqSection
